// React
import React from "react";
import CalendarEdit from "./CalendarEdit";

const CalendarEditAppointments = props => (
    <CalendarEdit {...props} calendarType="appointments" />
);
export default CalendarEditAppointments;